var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#828292",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.58647 1.57971C2.46092 1.51691 2.32026 1.49062 2.18051 1.50381C2.04075 1.517 1.9075 1.56914 1.79592 1.65432C1.68433 1.73949 1.59889 1.85427 1.54931 1.9856C1.49973 2.11693 1.48801 2.25954 1.51547 2.39721L3.61997 9.67221C3.65921 9.80778 3.73591 9.92953 3.84125 10.0235C3.94659 10.1174 4.0763 10.1797 4.21547 10.2032L12.7505 11.6327C13.1525 11.7122 13.1525 12.2882 12.7505 12.3677L4.21547 13.7972C4.0763 13.8207 3.94659 13.883 3.84125 13.977C3.73591 14.0709 3.65921 14.1926 3.61997 14.3282L1.51547 21.6032C1.48801 21.7409 1.49973 21.8835 1.54931 22.0148C1.59889 22.1461 1.68433 22.2609 1.79592 22.3461C1.9075 22.4313 2.04075 22.4834 2.18051 22.4966C2.32026 22.5098 2.46092 22.4835 2.58647 22.4207L22.0865 12.6707C22.2109 12.6084 22.3155 12.5126 22.3886 12.3942C22.4617 12.2758 22.5004 12.1394 22.5004 12.0002C22.5004 11.861 22.4617 11.7246 22.3886 11.6062C22.3155 11.4878 22.2109 11.3921 22.0865 11.3297L2.58647 1.57971Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/Send.77c947be.svg";
export { ForwardRef as ReactComponent };